import { adminDataType, pendingClientsType } from "src/types/apps/adminTypes";

export const adminData: adminDataType = {
    pendingClients: {
        data: [],
        loading: true,
        error: null,
    },
}